import { render } from "./GiftCard.vue?vue&type=template&id=87695bb6&scoped=true"
import script from "./GiftCard.vue?vue&type=script&lang=js"
export * from "./GiftCard.vue?vue&type=script&lang=js"

import "./GiftCard.vue?vue&type=style&index=0&id=87695bb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87695bb6"]])

export default __exports__